module.exports = __webpack_public_path__ + "static/media/ic-chevron-right.a0669c2e.svg";